import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableExchangeRateFragment = { readonly __typename?: 'SyncableExchangeRate', readonly id: string, readonly baseCurrency: Types.BillingCurrency, readonly quoteCurrency: Types.BillingCurrency, readonly buying: string, readonly selling: string, readonly mid: string, readonly effectiveDate: string, readonly fetchedAt: string, readonly source: Types.ExchangeRateSource, readonly sourceUrl: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncExchangeRatePullQueryVariables = Types.Exact<{
  input: Types.PullExchangeRateInput;
}>;


export type SyncExchangeRatePullQuery = { readonly __typename?: 'Query', readonly pullExchangeRate: { readonly __typename?: 'PullExchangeRateResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableExchangeRate', readonly id: string, readonly baseCurrency: Types.BillingCurrency, readonly quoteCurrency: Types.BillingCurrency, readonly buying: string, readonly selling: string, readonly mid: string, readonly effectiveDate: string, readonly fetchedAt: string, readonly source: Types.ExchangeRateSource, readonly sourceUrl: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableExchangeRateFragmentDoc = gql`
    fragment WholeSyncableExchangeRate on SyncableExchangeRate {
  id
  baseCurrency
  quoteCurrency
  buying
  selling
  mid
  effectiveDate
  fetchedAt
  source
  sourceUrl
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncExchangeRatePullDocument = gql`
    query SyncExchangeRatePull($input: PullExchangeRateInput!) {
  pullExchangeRate(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableExchangeRate
    }
  }
}
    ${WholeSyncableExchangeRateFragmentDoc}`;

/**
 * __useSyncExchangeRatePullQuery__
 *
 * To run a query within a React component, call `useSyncExchangeRatePullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncExchangeRatePullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncExchangeRatePullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncExchangeRatePullQuery(baseOptions: Apollo.QueryHookOptions<SyncExchangeRatePullQuery, SyncExchangeRatePullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncExchangeRatePullQuery, SyncExchangeRatePullQueryVariables>(SyncExchangeRatePullDocument, options);
      }
export function useSyncExchangeRatePullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncExchangeRatePullQuery, SyncExchangeRatePullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncExchangeRatePullQuery, SyncExchangeRatePullQueryVariables>(SyncExchangeRatePullDocument, options);
        }
export type SyncExchangeRatePullQueryHookResult = ReturnType<typeof useSyncExchangeRatePullQuery>;
export type SyncExchangeRatePullLazyQueryHookResult = ReturnType<typeof useSyncExchangeRatePullLazyQuery>;
export type SyncExchangeRatePullQueryResult = Apollo.QueryResult<SyncExchangeRatePullQuery, SyncExchangeRatePullQueryVariables>;